let resetValidationWarnings = function () {
    $("#addressVerify").prop("disabled", false);
    $("#address-container")
        .find(".alert")
        .each(function (key, ele) {
            ele.remove();
        });
};

function validateAddress(requestData, token) {
    $.ajax({
        type: "GET",
        url: "/api/v1/address/validate",
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        data: requestData,
        beforeSend: function () {
            $("#addressVerify").prop("disabled", true);
        },
        dataType: "json",
        encode: true,
        success: function (response) {
            resetValidationWarnings();

            let successDiv = document.createElement("div");
            successDiv.classList = "alert alert-success";
            successDiv.innerHTML = "This address has been verified.";

            $("#addressVerify").closest("div").prepend(successDiv);
            setTimeout(() => {
                $(successDiv).remove();
            }, 5000);
        },
        error: function (response) {
            console.log("hit error");
            resetValidationWarnings();
            // response.status == 422
            if (response.status == 422) {
                // missing fields to validate
                Toasty.displayToastWithMessage(
                    "warning",
                    "Please fill out all address fields to validate."
                );
                return;
            }

            let results = response.responseJSON;

            if (results.needsCorrection) {
                let recommendations =
                    results.recommendations.recommendedFields ?? {};
                let unconfirmed =
                    results.recommendations.unconfirmedFields ?? {};
                let missing = results.recommendations.missingFields ?? {};
                let corrected = results.recommendations.correctedFields ?? {};
                let addressOne =
                    results.recommendations.fullStreetAddress ?? "";

                let alertDiv = document.createElement("div");
                alertDiv.classList = "alert";

                if (Object.keys(recommendations).length) {
                    // Display our recommendations first
                    $.each(recommendations, function (key, value) {
                        let ourName = Address.convertGoogleName(key);
                        let recommendation = document.createElement("span");
                        let newAlert = alertDiv;

                        recommendation.classList = "bold";
                        recommendation.innerHTML = value;

                        newAlert.classList += " alert-warning";
                        newAlert.innerHTML = "Did you mean: ";
                        $(newAlert).append(recommendation);
                        newAlert.innerHTML += "?";

                        $("[name=" + ourName + "]")
                            .closest(".form-group")
                            .append(newAlert);
                    });
                } else if (Object.keys(corrected).length) {
                    $.each(corrected, function (key, value) {
                        let ourName = Address.convertGoogleName(key);
                        let recommendation = document.createElement("span");
                        let newAlert = alertDiv;

                        recommendation.classList = "bold";

                        if (ourName === "address_1") {
                            recommendation.innerHTML = addressOne;
                        } else {
                            recommendation.innerHTML = value;
                        }

                        newAlert.classList += " alert-warning";
                        newAlert.innerHTML = "Did you mean: ";
                        $(newAlert).append(recommendation);
                        newAlert.innerHTML += "?";

                        $("[name=" + ourName + "]")
                            .closest(".form-group")
                            .append(newAlert);
                    });
                } else {
                    // Otherwise tell them we couldn't verify
                    $.each(unconfirmed, function (key, value) {
                        let ourName = Address.convertGoogleName(value);
                        let newAlert = alertDiv;

                        newAlert.classList += " alert-danger";
                        newAlert.innerHTML = ourName + " could not be verified";

                        $("[name=" + ourName + "]")
                            .closest(".form-group")
                            .append(newAlert);
                    });

                    $.each(missing, function (key, value) {
                        let ourName = Address.convertGoogleName(value);
                        let newAlert = alertDiv;

                        newAlert.classList += " alert-danger";
                        newAlert.innerHTML = ourName + " could not be verified";

                        $("[name=" + ourName + "]")
                            .closest(".form-group")
                            .append(newAlert);
                    });
                }
            }
        },
    });
}

/**
 * Converts an address field from google to one of the project's field names
 * These should match the name attribute on the project's fields.
 *
 * @param {string} field Google field name
 * @returns {string} project field name
 */
function convertGoogleName(field) {
    let googleRename = {
        route: "address_1",
        street_number: "address_1",
        point_of_interest: "address",
        locality: "city",
        administrative_area_level_1: "state",
        postal_code: "zip",
    };

    return googleRename[field];
}

/**
 *
 * @param {Array.<string>} origins
 * @param {Array.<string>} destinations
 * @param {string} token Authorization token
 * @param {function} successCallback
 * @param {function} errorCallback
 */
function findDistanceBetween(
    origins,
    destinations,
    token,
    successCallback,
    errorCallback
) {
    $.ajax({
        type: "GET",
        url: "/api/v1/address/find/distance",
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        data: {
            origins: origins,
            destinations: destinations,
        },
        dataType: "json",
        encode: true,
        success: function (response) {
            successCallback(response);
        },
        error: function (response) {
            errorCallback(response);
        },
    });
}

export { validateAddress, convertGoogleName, findDistanceBetween };
